import type { ProductConfigDefinition } from 'Models/uiConfig/productConfig.types';

export default {
  fields: {
    id: 'id',
    image: 'image_thumbnail',
    title: 'name',
    url: 'custom_url',
  },
  getItemId: (): string => window.document.querySelector<HTMLInputElement>('input[name="product_id"]')!.value,
  getVariantId: (): undefined => undefined,
} satisfies ProductConfigDefinition;
